export const MEDIA_HOST: string = process.env.REACT_APP_MEDIA_HOST as string;
export const VIEWER_HOST: string = process.env.REACT_APP_VIEWER_HOST as string;
export const GRAPHQL_HOST: string = process.env.REACT_APP_GRAPHQL_HOST as string;
export const REDIRECT_HOST: string = process.env.REACT_APP_REDIRECT_HOST as string;
